import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import ForceGraph2D from 'react-force-graph-2d';
import * as d3 from 'd3-force';

const BASE_URL = process.env.REACT_APP_API_URL;

const TopicInsightsRealTime = () => {
  const [graphData, setGraphData] = useState({ nodes: [], links: [] });
  const fgRef = useRef();

  useEffect(() => {
    axios.get(`${BASE_URL}/engage/api/insights_realtime`)
      .then(res => {
        const rawData = Array.isArray(res.data) ? res.data : [];

        const nodes = [];
        const links = [];
        const seen = new Set();

        rawData.forEach(item => {
          const main = item["Behaviors"];
          const uniques = parseFloat(item["Uniques User Million"]) || 0.1;
          const pageviews = parseFloat(item["Pageviews in Million"]) || 0.1;

          const subBehaviors = [
            item["Sub Behavior 1"],
            item["Sub Behavior 2"]
          ].filter(sub => typeof sub === 'string' && sub.trim() !== '');

          const allTopics = [main, ...subBehaviors];

          allTopics.forEach((topic, i) => {
            if (!seen.has(topic)) {
              seen.add(topic);
              nodes.push({
                id: topic,
                val: i === 0 ? Math.min((uniques + pageviews) * 5, 12) : 1.5,
              });
            }
          });

          subBehaviors.forEach(sub => {
            if (main && sub) {
              links.push({ source: main, target: sub });
            }
          });
        });

        setGraphData({ nodes, links });
      })
      .catch(err => console.error("Error fetching data", err));
  }, []);

  useEffect(() => {
    if (!fgRef.current) return;

    fgRef.current.d3Force('charge', d3.forceManyBody().strength(-250)); // More repulsion
    fgRef.current.d3Force('collide', d3.forceCollide(node => Math.sqrt(node.val) * 22)); // More spacing

    // Optional: prevent label overlapping
    fgRef.current.d3Force('link').distance(120);
  }, [graphData]);

  return (
    <div className="w-full h-[85vh] bg-white">
      <h1 className="text-xl font-bold text-center mt-4">Topic of Insights - Real Time</h1>
      <ForceGraph2D
        ref={fgRef}
        graphData={graphData}
        nodeLabel="id"
        nodeAutoColorBy="id"
        cooldownTicks={180}
        onEngineStop={() => fgRef.current?.zoomToFit(500, 60)}
        d3VelocityDecay={0.15}
        onNodeDragEnd={node => {
          node.fx = node.x;
          node.fy = node.y;
        }}
        nodeCanvasObject={(node, ctx, globalScale) => {
          const label = node.id;
          const fontSize = Math.max(14, Math.min(node.val * 14 / globalScale, 30));
          ctx.font = `${fontSize}px Sans-Serif`;
          ctx.fillStyle = node.color || 'black';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(label, node.x, node.y);
        }}
        nodePointerAreaPaint={(node, color, ctx) => {
          ctx.fillStyle = color;
          const radius = 14;
          ctx.beginPath();
          ctx.arc(node.x, node.y, radius, 0, 2 * Math.PI, false);
          ctx.fill();
        }}
      />
    </div>
  );
};

export default TopicInsightsRealTime;
